import {Component, Input} from '@angular/core';

import {SubtitlesService} from "../../core";
import {AlarmZoneTile} from "../../models";
import {AlarmMessageData} from "../../models/alarms";
import {FormatPipe} from "../../shared";

@Component({
    selector: 'zones-alarm-tile',
    templateUrl: './zones-alarm-tile.component.html',
    styleUrls: ['./zones-alarm-tile.component.scss']
})
export class ZonesAlarmTileComponent {
    @Input() tile: AlarmZoneTile;

    constructor(
        public subtitles: SubtitlesService,
        private formatPipe: FormatPipe,
    ) {
    }

    subtitle(val: number): string {
        return this.subtitles.setSubtitle(val);
    }

    formatAlarmText(data: AlarmZoneTile): string {
        const subtitle = this.subtitles.setSubtitle(data.txtId);
        const unit = typeof data.unit === 'number' ? data.unit : 0;
        const valueWithUnit = this.formatPipe.transform(data.value, unit);
        return `${subtitle} ${valueWithUnit}`;
    }
}
